export { default } from "./survey";
